import React, { useState, useEffect } from 'react';

const KEY = 'lumera_nowfree_seen';

const readSeen = () => {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || '[]')); }
  catch { return new Set(); }
};

// Mark a "Now Free" discovery pill as seen so it disappears once the user
// opens that tool for the first time. Also logs the first-open for analytics.
export const markNowFreeSeen = (k) => {
  const s = readSeen();
  if (s.has(k)) return;
  s.add(k);
  localStorage.setItem(KEY, JSON.stringify([...s]));
  window.dispatchEvent(new Event('lumera:nowfree-seen'));
  try {
    const base = process.env.REACT_APP_BACKEND_URL;
    const audience = localStorage.getItem('token') ? 'member' : 'guest';
    fetch(`${base}/api/analytics/nowfree`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tool: k, audience }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* ignore */ }
};

// A tiny amber/emerald "Now Free" pill that hides itself once its tool is opened.
export const NowFreeBadge = ({ seenKey, language = 'en', className = '' }) => {
  const [seen, setSeen] = useState(() => readSeen().has(seenKey));
  useEffect(() => {
    const h = () => setSeen(readSeen().has(seenKey));
    window.addEventListener('lumera:nowfree-seen', h);
    return () => window.removeEventListener('lumera:nowfree-seen', h);
  }, [seenKey]);
  if (seen) return null;
  return (
    <span
      className={`inline-flex items-center rounded-full bg-emerald-500 text-white text-[9px] font-extrabold tracking-wide px-1.5 py-0.5 leading-none shadow-sm ${className}`}
      data-testid={`nowfree-${seenKey}`}
    >
      {language === 'es' ? 'GRATIS' : 'NOW FREE'}
    </span>
  );
};

export default NowFreeBadge;
